import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import SideBar from '@/components/navigation/SideBar.tsx';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from '@/components/error/ErrorFallback.tsx';
import NotFound from '@/components/navigation/NotFound.tsx';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Toaster, type ToasterProps } from 'sonner';
import { ConfirmDialog } from '@/components/ui/ConfirmDialog';
import ScrollTrackAndRestore from '@/components/common/ScrollTrackAndRestore';
import { SessionRefreshManager } from '@/components/auth/SessionRefreshManager';
import { WorkflowAssignTasksDialogHost } from '@/components/workflow/WorkflowAssignTasksDialogHost';

interface MyRouterContext {
  queryClient: QueryClient;
}
const snackbarOptions = {
  className:
    'rounded-[8px] px-4 py-3 shadow-lg !border-transparent !outline-none !font-medium font-inter text-[14px]',
  classNames: {
    success: '!bg-success-S-dark !text-white',
    warning: '!bg-warning-W-dark !text-white',
    error: '!bg-error-E-dark !text-white',
    info: '!bg-[#F0F8FF] !text-[#328AE2]',
  },
  closeButton: true,
  duration: 2500,
} satisfies ToasterProps['toastOptions'];

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: () => (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <SideBar.Provider>
        <Toaster richColors toastOptions={snackbarOptions} expand position="top-right" />
        <ConfirmDialog />
        {/* <WorkflowAssignTasksDialogHost /> */}
        <ScrollTrackAndRestore />
        <SessionRefreshManager />
        <Outlet />
      </SideBar.Provider>
      {import.meta.env.DEV && <ReactQueryDevtools buttonPosition="bottom-right" />}
    </ErrorBoundary>
  ),
  notFoundComponent: NotFound,
});
